module.exports = __webpack_public_path__ + "static/media/nivel 1_400.a04b159e.jpg";